import store from '../store/index'

export const isTest = () => window.location.host.startsWith('apph5.');
export const isLocal = () => !window.location.host.startsWith('apph5');
const _gol = window;
export const inApp = () => !!_gol.ReactNativeWebView
export const isNative = () => store.state.user.isNative || false
export default {
  /**
   * app 环境 false 测试，true 正式
   */
  app: isTest(),
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://rnapitest.jaadee.net/',
    pro: 'http://rnapi.jaadee.net/'
  },
  basesUrl: {
    dev: 'https://rnapitest.jaadee.net/',
    pro: 'https://rnapi.jaadee.net/'
  },

  /**
   * @descriptionJava Api请求基础路径
   */
  newApi:{
    dev: "https://newapitest.jaadee.net/index.php/v2/",
    pro: "https://newapi.jaadee.net/index.php/v2/"
  },

  /**
   * 本站app 测试地址和正式
   */
  appUrl: {
    dev: "https://apph5test.jaadee.com",
    test: "http://192.168.31.249:8080",
    pro: "https://apph5.jaadee.com",

  },
  payBaseUrl: {
    dev: 'https://jtestpay.jaadee.net/app/',
    pro: 'https://pay.jaadee.net/app/'
  },
  /**
   * java微服务
   */
  javaBaseUrl: {
    dev: 'https://jtest.jaadee.net/',
    pro: 'https://bgate.jaadee.net/'
  },
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
}
